/* eslint-disable */
'use client';
import { Cart } from '../../../interface/checkoutInterface';
import { RawEvent } from '../../../interface/eventInterface';
import { Tracker } from '../trackers';

export class GoogleAdsTracker implements Tracker {
  private conversionID: string;
  private conversionLabel: string;

  constructor(conversionID: string, conversionLabel: string) {
    if (!conversionID || !conversionLabel) {
      throw new Error(
        'GoogleAdsTracker requires both a Conversion ID and Conversion Label.',
      );
    }
    this.conversionID = conversionID;
    this.conversionLabel = conversionLabel;
  }

  Init(): void {
    this.initializeGtag();
  }

  private initializeGtag() {
    if (!(window as any).dataLayer) {
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${this.conversionID}`;
      document.head.appendChild(gtagScript);

      (window as any).dataLayer = [];
      const gtag = (...args: any[]) => (window as any).dataLayer.push(args);
      gtag('js', new Date());
      gtag('config', this.conversionID);
    }
  }

  TrackEvent(event: RawEvent): void {
    const cart: Cart | undefined = event?.cart;

    const value = parseFloat(cart?.TotalAmount || '0');
    const currency = 'USD'; // Customize or extract dynamically

    const gtag = (...args: any[]) => (window as any).dataLayer.push(args);

    switch (event.eventName) {
      case 'Purchase':
        this.handlePurchase(gtag, value, currency, cart?.ID || '');
        break;
      default:
        this.trackDefaultEvent(gtag, event.eventName);
        break;
    }
  }

  private handlePurchase(
    gtag: (
      _event: string,
      _action: string,
      _params: { [key: string]: any },
    ) => void,
    value: number,
    currency: string,
    orderId: string,
  ): void {
    gtag('event', 'conversion', {
      send_to: `${this.conversionID}/${this.conversionLabel}`,
      value: value,
      currency: currency,
      transaction_id: orderId,
    });
  }

  private trackDefaultEvent(
    gtag: (
      _event: string,
      _action: string,
      _params: { [key: string]: any },
    ) => void,
    eventName: string,
  ): void {
    gtag('event', eventName, {
      send_to: `${this.conversionID}/${this.conversionLabel}`,
    });
  }
}
